module.exports = {
    configuration_upload_mode_title: "Configuración Modo de Carga",
    configuration_upload_mode_all_events: "Todos los Eventos",
    configuration_upload_mode_group_events: "Grupos de Eventos",
    configuration_upload_mode_specific_events: "Eventos Específicos",
    configuration_upload_mode_all_accel_events: "Eventos de Aceleración",
    configuration_upload_mode_all_dms_events: "Eventos DMS",
    configuration_upload_mode_all_adas_events: "Eventos ADAS",
    configuration_upload_mode_all_nav_events: "Eventos Nav",
    configuration_upload_mode_events: "Eventos",
    configuration_upload_mode_accel_events: "Eventos de Aceleración",
    configuration_upload_mode_dms_events: "Eventos DMS",
    configuration_upload_mode_adas_events: "Eventos ADAS",
    configuration_upload_mode_others_events: "Otros Eventos",
    configuration_upload_mode_clip: "Clip",
    configuration_upload_mode_picture: "Imagen",

    configuration_upload_mode_severe_brake: "Freno Severo",
    configuration_upload_mode_hard_brake: "Freno Duro",
    configuration_upload_mode_harsh_brake: "Freno Brusco",
    configuration_upload_mode_harsh_accel: "Aceleracion Brusca",
    configuration_upload_mode_harsh_turn: "Giro Brusco",
    configuration_upload_mode_sharp_turn: "Giro Cerrado",
    configuration_upload_mode_severe_turn: "Giro Severo",
    configuration_upload_mode_driving_hit: "Choque",
    configuration_upload_mode_severe_accel: "Aceleración Severa",
    configuration_upload_mode_driving_heavy_hit: "Choque Fuerte",
    configuration_upload_mode_hard_accel: "Aceleración Dura",

    configuration_upload_mode_using_phone: "Usando el Teléfono",
    configuration_upload_mode_smoking: "Fumando",
    configuration_upload_mode_drowsiness: "Somnolencia",
    configuration_upload_mode_no_seatbelt: "Sin Cinturón de Seguridad",
    configuration_upload_mode_no_driver: "Sin Conductor",
    configuration_upload_mode_daydreaming: "Soñador",
    configuration_upload_mode_yawn: "Bostezo",
    configuration_upload_mode_asleep: "Dormido",
    configuration_upload_mode_distracted: "Distraído",

    configuration_upload_mode_forward_collision_warning: "Advertencia de Colisión Frontal",
    configuration_upload_mode_headway_monitoring_warning: "Advertencia de Monitoreo de Avance",
    configuration_upload_mode_headway_monitoring_emergency: "Emergencia de Monitoreo de Avance",
    configuration_upload_mode_lane_departure_warning: "Advertencia de Cambio de Carril",

    configuration_upload_mode_manual: "Manual",

    configuration_upload_mode_save_title: "Guardado de configuración de modo de carga",
    configuration_upload_mode_save_success: "Configuración de modo de carga guadado",
    configuration_upload_mode_save_error: "Error en el guardado de la configuración modo de carga",

    configuration_upload_mode_next: "Siguiente",
    configuration_upload_mode_back: "Atrás",
    configuration_upload_mode_apply: "Aplicar",
    configuration_upload_mode_potential_incident_low: "Incidente Potencial Bajo",
    configuration_upload_mode_potential_incident_medium: "Incidente Potencial Medio",
    configuration_upload_mode_potential_incident_high: "Incidente Potencial Alto",
    configuration_upload_mode_driving_suspicious_hit: "Choque Sospechoso",
    configuration_upload_mode_idle_no_driver: "Activo sin Conductor",
    configuration_upload_mode_power_lost: "Perdida de Poder",
    configuration_upload_mode_none: "Ninguno",
    configuration_upload_mode_parking_motion: "Movimiento de Parqueadero",
    configuration_upload_mode_parking_hit: "Choque de Parqueadero",
    configuration_upload_mode_parking_heavy_hit: "Choque Fuerte de Parqueadero",
    configuration_upload_mode_driving_hit: "Choque",
    configuration_upload_mode_stop_sign_violation: "Violación de la Señal de Parada",
    configuration_upload_mode_pedestrian_collision: "Colisión con Peaton",
    configuration_upload_mode_cyclist_collision: "Colisión con Ciclista",

    configuration_upload_mode_nav: "Eventos de Navegación",
    configuration_upload_mode_speeding: "Exceso de Velocidad",
    configuration_upload_mode_over_max_speed: "Velocidad Máxima Excedida",

}